import { ArrayHelper, IBaseModel, IOptionType } from '@zz2/zz2-ui';
import lodash from 'lodash';
import { ISite } from './masterData/site/site';
import { IPackCategory } from './masterData/packCategory/packCategory';

interface ILabelSection {
    order : number;
    section : string;
}

export default class OptionType {
    public static fromDataModel = function<T extends IBaseModel>(dataModel : T) : IOptionType {
        let labelSections : Array<ILabelSection> = [];

        if ('code' in dataModel && typeof dataModel.code === 'string' && dataModel.code !== '') {
            const labelSection : ILabelSection = {
                order: 1,
                section: dataModel.code.trim(),
            };

            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if ('name' in dataModel && typeof dataModel.name === 'string' && dataModel.name !== '') {
            const labelSection : ILabelSection = {
                order: 2,
                section: dataModel.name.trim(),
            };
            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if ('description' in dataModel
            && typeof dataModel.description === 'string'
            && dataModel.description !== ''
            && labelSections.length < 2) { // We don't want to add a description if the code and name have already been added.
            const labelSection : ILabelSection = {
                order: 3,
                section: dataModel.description.trim(),
            };
            labelSections = ArrayHelper.addElement(labelSections, labelSection, 'end');
        }

        if (labelSections.length < 1) {
            return {
                label: 'Label Not Found',
                value: dataModel.id,
            };
        }

        if (labelSections.length > 1) {
            const orderedList = lodash.orderBy(labelSections, x => x.order, 'asc');
            return {
                label: `(${orderedList[0].section}) - ${orderedList[1].section}`,
                value: dataModel.id,
            };
        } else {
            return {
                label: labelSections[0].section,
                value: dataModel.id,
            };
        }
    };

    /*================================================================================================================
*                                                 Custom Option Type Map
     * ==============================================================================================================*/

    /*=============================================== Enums =========================================================*/

    /*=============================================== Master Data ===================================================*/

    public static fromPackCategory = (packCategory : IPackCategory) : IOptionType => {
        return {
            label: `(${packCategory.code}) ${packCategory.category}`,
            value: packCategory.id,
        };
    };

    public static fromSite = (site : ISite) : IOptionType => {
        return {
            label: `(${site.shortDescription}) ${site.description}`,
            value: site.id,
        };
    };

    /*=============================================== Auth Data =====================================================*/
}
